import React from "react";
import { useNavigate } from "react-router-dom";
import { UserCircle } from "@phosphor-icons/react";

/**
 * CustomerLink — click anywhere to open the same 360° customer profile.
 * Renders customer name (and optionally photo/id) as a subtle clickable pill.
 */
export default function CustomerLink({ id, name, photo, mobile, showPhoto = false, className = "", testid, subline }) {
  const nav = useNavigate();
  if (!id) return <span className="text-slate-400">—</span>;

  const open = (e) => {
    e.stopPropagation();
    nav(`/customers?id=${id}`);
  };

  return (
    <button
      type="button"
      onClick={open}
      data-testid={testid || `customer-link-${id}`}
      className={`inline-flex items-center gap-2 text-left group ${className}`}
      title="Open 360° customer profile"
    >
      {showPhoto && (photo ? (
        <img src={photo} alt="" className="w-9 h-9 rounded-full object-cover border border-slate-200" />
      ) : (
        <div className="w-9 h-9 rounded-full bg-slate-100 flex items-center justify-center text-slate-500"><UserCircle size={22} /></div>
      ))}
      <span>
        <span className="font-medium text-slate-900 group-hover:text-orange-600 group-hover:underline underline-offset-4 transition-colors">{name || "Unknown"}</span>
        {subline && <span className="block text-xs text-slate-500">{subline}</span>}
        {mobile && !subline && <span className="block text-xs text-slate-500">{mobile}</span>}
      </span>
    </button>
  );
}
